<template>
    <banner :bgImage="bannerInfo.file || bgImage"  :title="bannerInfo.title" :subTitle="bannerInfo.desc"></banner>
    <div class="main-bg">
        <div class="wrap">
            <Ani class="join-top" ID="Ani-join-top" v-if="officeEnv?.dataList?.length">
                <ul class="join-list flex">
                    <template v-for="(item, index) in officeEnv?.dataList" :key="index">
                        <li v-if="index < 4" :class="{active: cardIndex == index}" @mouseenter="cardIndex = index">
                            <div class="join-item">
                                <el-image class="join-img has-backstop" :src="item.image" lazy style="width: 100%; height: 100%">
                                    <template #error>
                                        <div class="no-pic">
                                            <img src="@/assets/images/iconSvg/logo_no_pic.svg" :alt="item.title" />
                                        </div>
                                    </template>
                                </el-image>
                                <h3 class="join-title font16 color-f text-center ellipsis">{{ item.title }}</h3>
                            </div>
                        </li>
                    </template>
                </ul>
            </Ani>
            <div class="join-bot">
                <Ani class="box-title text-center">
                    <h2 class="box-h2 font36 color-f">{{t('about.job') }}</h2>
                </Ani>
                <el-collapse class="join-list" accordion v-if="job?.dataList?.length">
                    <Ani>
                        <div v-for="(item, index) in job?.dataList" :key="index">
                            <el-collapse-item :name="index">
                                <template #icon="{ isActive }">
                                    <span class="join-icon" :class="{ 'is-active': isActive }"></span>
                                </template>
                                <template #title="{ isActive }">
                                    <h3 :class="['join-title font16 color-f ellipsis', { 'is-active': isActive }]">
                                        {{ item.title }}
                                    </h3>
                                </template>
                                <div class="join-text">
                                    <div v-html="item.detail"></div>
                                    <!-- <a class="join-btn btn-default font16 color-f" :href="item.url">{{t('about.notes')}}</a> -->
                                    <div class="join-btn btn-default font16 color-f" @click="resume(item.url)">{{t('about.notes')}}</div>
                                </div>
                            </el-collapse-item>
                        </div>
                    </Ani>
                </el-collapse>
                 <error :status="status" v-if="status==1"></error>
            </div>
        </div>
    </div>
    <error :status="status" v-if="status==2"></error>
</template>
<script setup lang="ts">
    import { ref } from 'vue'
    import useServerRequest from '@/composables/useServerRequest'
    import type { configParams, configResponse,bannerConfig } from '~/types'
    import { useI18n } from 'vue-i18n'
    import { Picture } from '@element-plus/icons-vue'
    import { handleApiResponse } from "@/utils/utils"
    import { useRoute } from 'vue-router'
    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy
    // 2. 获取当前路由和语言
    const route = useRoute()
    const { locale,t } = useI18n()

    // 3. 初始化响应式数据
    const bgImage = ref<string>(staticURL('/banner/join-banner.webp'))
    interface banner{
        title:string,
        text:string,
        crumbList:object
    }
    const status = ref<number>(0)
    //其他信息
    const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
})
    const bannerInfo = ref<bannerConfig>({})
    const job = ref<configResponse['pageValue']['job']>({
        dataList: []
    })
    const officeEnv = ref<configResponse['pageValue']['officeEnv']>({
        dataList: []
    })
    const infoParams = ref<configParams>({
        pageCode: "RECRUITMENT_INFO"
    })
    const getInfo = async () => {
        try {
            const { data } = await useServerRequest<configResponse>(
                'join-info',
                `${cmsurlStrategy}/getPageConfig`,
                { method: 'GET', params: infoParams.value, language: locale.value }
            )
            const res = data?.value
            const result = handleApiResponse(res)
            if (!result.success) {
                status.value = result.status
                return
            }
            const getInfoData = data?.value?.data?.pageValue
            seo.value = getInfoData?.seo
            bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
            officeEnv.value=getInfoData?.officeEnv
            job.value=getInfoData?.job
            console.log(job.value)
            
        } catch (error) {
            status.value = 2
        }
    }
    getInfo()
    useHead({
        title: () => seo?.value?.title || '', // 保持不变（已正确）
        meta: [
          { 
            name: 'keywords', 
            content: () => seo?.value?.keywords || '' // 改为函数形式！
          },
          { 
            name: 'description', 
            content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
          }
        ]
     })
    const cardIndex = ref(0)
   

   const resume = (url:string) => {
    findBuryKey('Recruitment_Page_resume_button')
    window.open(url)
   }
</script>
<style scoped lang="scss">
@use '@/assets/css/about.scss';
</style>